// PWA Service Worker — App-Shell-Caching + Offline-Fallback (siehe public/sw.js).
//
// WICHTIG (Lehre aus dem früheren Login-Loop): Hier KEIN `controllerchange`-
// Listener mit `window.location.reload()`. Genau diese Kombination (skipWaiting +
// clients.claim → controllerchange → reload → neuer SW-Update → …) hat nach dem
// OIDC-Login die Endlosschleife erzeugt. Updates greifen jetzt bei der nächsten
// natürlichen Navigation — ohne erzwungenen Reload.
export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((e) => {
      // Registrierung scheitern lassen ist unkritisch — App läuft auch ohne SW.
      console.warn('[PWA] Service-Worker-Registrierung fehlgeschlagen:', e);
    });
  });
}
